module.exports = __webpack_public_path__ + "assets/img/16_1816_big.03cb2e58.jpg";